import { c as _c } from "react/compiler-runtime";
import { IFRAME_SEARCH_PARAM_KEYS } from '@/constants/iframe';
import { getWorldsDomain } from '@/lib/configs';
import { buildIframeUrl } from '@/lib/iframe';
import { useParams, useSearchParams } from 'next/navigation';
export function useMobileWorldRedirectUrlBuilder() {
  const $ = _c(5);
  const searchParams = useSearchParams();
  const {
    roomId
  } = useParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = Object.fromEntries(searchParams.entries());
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const baseQueryParams = t0;
  let t1;
  if ($[2] !== baseQueryParams || $[3] !== roomId) {
    t1 = t2 => {
      const {
        isFull3d
      } = t2 === undefined ? {} : t2;
      return buildMobileWorldRedirectUrl({
        roomId: roomId as string,
        isFull3d,
        otherParams: baseQueryParams
      });
    };
    $[2] = baseQueryParams;
    $[3] = roomId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function buildMobileWorldRedirectUrl({
  roomId,
  isFull3d,
  otherParams = {}
}: {
  roomId: string;
  isFull3d?: boolean;
  otherParams: Record<string, string>;
}): string {
  //const worldsDomain = LOCAL_ORIGIN
  const worldsDomain = `https://${getWorldsDomain()}`;
  const baseUrl = `${worldsDomain}/${roomId}`;
  if (isFull3d) {
    otherParams[IFRAME_SEARCH_PARAM_KEYS.FULL3D] = '';
  } else {
    delete otherParams[IFRAME_SEARCH_PARAM_KEYS.FULL3D];
  }
  otherParams[IFRAME_SEARCH_PARAM_KEYS.VRAM_LIMIT_PASSED] = '';
  return buildIframeUrl(baseUrl, {
    otherParams
  });
}